<h1 matDialogTitle>{{data.title}}</h1>

<mat-dialog-content>
    <div class="text-container">
        {{data.text}}
    </div>
    
    <div class="label">Please select a reason:</div>
    <mat-select [(ngModel)]="selectedReasonCode" placeholder="Reason">
        <mat-option *ngFor="let reason of reasons" [value]="reason.reasonCode">{{reason.description}}</mat-option>
    </mat-select>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button *ngIf="data.showCancelButton" (click)="cancelClicked()">Close</button>
    <button mat-button *ngIf="data.showConfirmButton" (click)="confirmClicked()"
        [disabled]="!selectedReasonCode">{{data.confirmButtonText}}</button>
</mat-dialog-actions>